import React from 'react';
import { ReactComponent as SyncBtn } from '../assets/images/icons/md-refresh.svg';
import { ReactComponent as EditBtn } from '../assets/images/icons/edit.svg';
import { ReactComponent as DeleteBtn } from '../assets/images/icons/delete-12-regular.svg';
import { ReactComponent as SendBtn } from '../assets/images/icons/paper-plane-f.svg';
import { ReactComponent as Map } from '../assets/images/icons/map-location-solid.svg';
import { ReactComponent as MapSolid } from '../assets/images/icons/bxs-map.svg';
import { ReactComponent as Close } from '../assets/images/icons/close-md.svg';
import { ReactComponent as View } from '../assets/images/icons/view.svg';
import { ReactComponent as Filter } from '../assets/images/icons/filter-outline.svg';
import { ReactComponent as DocExcel } from '../assets/images/icons/filetype-xls.svg';
import { ReactComponent as DocPDF } from '../assets/images/icons/filetype-pdf.svg';
import { ReactComponent as DocCSV } from '../assets/images/icons/filetype-csv.svg';
import { ReactComponent as PrintReport } from '../assets/images/icons/printer.svg';
import { ReactComponent as RightArrrow } from '../assets/images/icons/arrow-right.svg';
import { ReactComponent as History } from '../assets/images/icons/history.svg';
import { ReactComponent as RightTick } from '../assets/images/icons/tick.svg';
import { ReactComponent as ChangePass } from '../assets/images/icons/lock-password-outline.svg';
import { ReactComponent as Watch } from '../assets/images/icons/stopwatch.svg';
import { ReactComponent as Add } from '../assets/images/icons/add-plus.svg';

interface IconProps {
  icon: string; //make the clear type to make switch
  color?: string;
  width?: number;
}

const SVGIcon = ({ icon, color = '#696b71', width = 14 }: IconProps) => {
  // In this case you have to think about the switch and types in typescript.
  const Icons: any = {
    refresh: <SyncBtn fill={color} width={width} height={width} />,
    close: <Close fill={color} width={width} height={width} />,
    edit: <EditBtn fill={color} width={width} height={width} />,
    delete: <DeleteBtn fill={color} width={width} height={width} />,
    send: <SendBtn fill={color} width={width} height={width} />,
    view: <View fill={color} width={width} height={width} />,
    map: <Map fill={color} width={width} height={width} />,
    mapSolid: <MapSolid fill={color} width={width} height={width} />,
    filter: <Filter fill={color} width={width} height={width} />,
    docExcel: <DocExcel fill={color} width={width} height={width} />,
    docPDF: <DocPDF fill={color} width={width} height={width} />,
    docCSV: <DocCSV fill={color} width={width} height={width} />,
    PrintReport: <PrintReport fill={color} width={width} height={width} />,
    right_arrow: <RightArrrow fill={color} width={width} height={width} />,
    history: <History fill={color} width={width} height={width} />,
    rightTick: <RightTick fill={color} width={width} height={width} />,
    changePass: <ChangePass fill={color} width={width} height={width} />,
    watch: <Watch fill={color} width={width} height={width} />,
    add: <Add fill={color} width={width} height={width} />,

  };
  return Icons[icon];
};

export default SVGIcon;
